import { useRef, useState, useEffect } from 'react';
import { TableInstance, useExpanded, useTable, useSortBy } from 'react-table';
import { TableRowDataType } from './types';

export const useTableRef = <TableRowData extends TableRowDataType>() => {
  const tableRef = useRef<TableInstance<TableRowData>>();
  const [tableInstance, setTableInstance] = useState<TableInstance<TableRowData>>();

  useEffect(() => {
    if (tableRef.current) setTableInstance(tableRef.current);
  }, [tableRef]);

  return {
    tableRef,
    tableInstance,
  };
};

export { useExpanded, useTable, useSortBy };
